import api from '~/services';
import { log } from '~/helpers';
import * as actionTypes from './actionTypes';

export const fetchTagsSuccess = callTags => async dispatch => {
  dispatch({
    type: actionTypes.TAGS_STORE_SUCCESS,
    payload: callTags,
  });
};

export const getTagsByCallId = (
  callId,
  sipCallId,
  originalSipCallId
) => async dispatch => {
  try {
    if (callId) {
      dispatch({ type: actionTypes.TAGS_STORE });

      let tags;

      if ((sipCallId && sipCallId !== callId) || originalSipCallId) {
        // Use new API that supports multiple callIDs lookup
        const response = await api.tags.fetchCallTags(
          callId,
          sipCallId,
          originalSipCallId
        );
        const rawTags = response && response.data;
        // Normalize response to match old API format (id -> tag_id)
        tags = rawTags?.map(tag => ({
          tag_id: tag.id || tag.tag_id,
          tag_name: tag.tag_name,
          tag_color: tag.tag_color,
          assigned: tag.assigned,
        }));
      } else {
        const response = await api.tags.get.getTag(callId);
        tags = response && response.data;
      }

      dispatch(
        fetchTagsSuccess({
          callId,
          tags,
        })
      );
    }
  } catch (err) {
    log.error('Failed to get all tags by call ID.', err);
  }
};

export const addCallTagById = (callId, tagId) => async (dispatch, getState) => {
  if (!callId || !tagId) {
    throw new Error('Missing callId or tagId.');
  }

  const allTags = getState().tags.data;
  const callTags = allTags[callId] ? allTags[callId] : [];

  const assignedIndex = callTags.findIndex(
    e => Number(e.tag_id) === Number(tagId)
  );

  if (assignedIndex === -1) {
    throw new Error(`TagId was not found in the local store for callId.`);
  }

  // Optimistic update: update UI immediately, then sync with API
  const updatedTags = callTags.map((tag, index) =>
    index === assignedIndex ? { ...tag, assigned: 1 } : tag
  );

  dispatch(
    fetchTagsSuccess({
      callId,
      tags: updatedTags,
    })
  );

  await api.tags.post.addCallTag({
    call_id: callId,
    tag_id: tagId,
  });
};

export const deleteTagById = (callId, tagId) => async (dispatch, getState) => {
  try {
    if (callId && tagId) {
      const allTags = getState().tags.data;
      const callTags = allTags[callId] ? allTags[callId] : [];

      const deletedIndex = callTags.findIndex(e => Number(e.tag_id) === tagId);

      callTags[deletedIndex].assigned = 0;
      dispatch(fetchTagsSuccess(callTags));

      await api.tags.delete.callTag({
        call_id: callId,
        tag_id: tagId,
      });
    }
  } catch (err) {
    log.error('Failed to execute delete tag by ID action.', err);
  }
};

export const createNewTag = (tagName, tagColor) => async () => {
  try {
    await api.tags.post.createTag({
      tag_name: tagName,
      tag_color: tagColor,
    });
  } catch (err) {
    log.error('Failed to execute create tag action.', err);
  }
};
